export enum AbsenceType {
  Occasional = 1,
  Vacation = 2,
  ChildCareLeave = 3,
  UnpaidAbsence = 4,
  NewJobSearchLeave = 5,
  BloodDonorLeave = 6,
  UnexcusedAbsence = 7,
  ExcusedAbsence = 8,
  OnDemandLeave = 9,
  SickLeave = 10,
  MaternityLeave = 11,
  FatherMaternityLeave = 12,
  PaternityLeave = 13,
  ParentalLeave = 14,
  ExtraParentalLeave = 15,
  UnpaidSuspension = 16,
  UnpaidCareLeave = 23
}
